import "./Home.css";
import { useState } from "react";
// import back from "./Images/back.png";
export const Home = () => {
  // window.addEventListener("scroll",function(){
  //   const header=this.document.querySelector("header")
  //           header.classList.toggle("active",this.window.scrollY>0)
  //       })
  const [show,setShow]=useState(false);
  

  return (
      <>
    <div className="home " id="Home">
      <div className="home__bg " style={{ backgroundImage: `url(https://raw.githubusercontent.com/nisarhassan12/portfolio-template/master/images/header.jpg)` }}>
        <div className="header d__flex align__items__center pxy__30 nav1 ">
 
         
          <div className="navigation pxy__30 ">
            <ul className="navbar d__flex ">
              

            <a href="#Contact">
                <li className="nav__items mx__15 link">Contact</li>
              </a>
              
              <a href="#Projects">
                <li className="nav__items mx__15 link">Projects</li>
              </a>
              <a href="#skills" >
                <li className="nav__items mx__15">Skills</li>
              </a>
              <a href="#about">
                <li className="nav__items mx__15">About</li>
              </a>
              <a href="#Home">
                <li className="nav__items mx__15 link">Home</li>
              </a>
            </ul>
          </div>
          <div className="toggle__menu">
          <svg onClick={()=>{
            setShow(!show)

          }} xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="currentColor" class="bi bi-list white pointer" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
</svg>
          </div>
          {show? (
          <div className="sideNavbar">
            <ul className="sidebar d__flex">
              {/* <li className="sidebar"></li> */}
              <a href="#Home">
                <li className="sidebar">Home</li>
              </a> 
            <a href="#about">
                <li className="sidebar">About</li>
              </a> 
              <a href="#skills" >
                <li className="sidebar">Skills</li>
              </a> 
              <a href="#Projects">
                <li className="sidebar">Projects</li>
              </a>
            <a href="#Contact">
                <li className="sidebar">Contact</li>
              </a>  
             
            </ul>
          </div>):false}
        </div>

        <div className="container ">
          <div className="home__content">
            <div className="home__meta home1 ">
              {/* <h1 className="home__text pz__10">
                            Welcome To world
                        </h1> */}
              <h2 className="home__text pz__10">Hello 👋</h2>
              <h2 className="home__text pz__10">I'm Bhavani Dasari</h2>
              <h3 className="home__text sweet pz__10">Web Developer</h3>
              {/* <h6 className="home__text pz__10 text">
               
              </h6> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
